import { Plugin as e, PluginKey as t } from "@tiptap/pm/state";
import { TextStyle as n } from "@tiptap/extension-text-style";
//#region src/extensions/text-style-extension/index.ts
var r = new t("restoreMarks"), i = n.extend({ addProseMirrorPlugins() {
	return [a()];
} }), a = () => new e({
	key: r,
	appendTransaction: (e, t, n) => {
		let r = e.some((e) => e.docChanged), i = !t.selection.eq(n.selection);
		if (!r && !i) return null;
		let { $head: a } = n.selection;
		if (a.parent.type.name === "paragraph" && o(a.parent)) {
			let e = n.storedMarks || a.marks();
			if ((!e || e.length === 0) && (e = s(n.doc, a.before())), e && e.length > 0) {
				let t = [
					"bold",
					"italic",
					"strike",
					"underline",
					"textStyle",
					"textColor",
					"textBackgroundColor",
					"fontSize",
					"fontFamily"
				], r = e.filter((e) => t.includes(e.type.name));
				if (r.length > 0) {
					let e = n.tr;
					return e.setStoredMarks(r), e;
				}
			} else {
				let e = n.tr;
				return e.setStoredMarks([]), e;
			}
		}
		return null;
	}
}), o = (e) => e.content.size === 0 || e.childCount === 1 && e.firstChild?.type.name === "hardBreak", s = (e, t) => {
	let n = [];
	return e.nodesBetween(0, t, (t, r) => {
		if (t.isTextblock) return o(t) || (n = e.resolve(r + t.nodeSize - 1).marks()), !1;
	}), n;
};
//#endregion
export { i as TextStyle };
